<template>
  <A11yDropdown
    :dropdown-props="{
      class:'inline-block',
      ref:'dropdown'
    }"
    :button-props="{
      class:'btn btn-default dropdown-toggle',
      type:'button',
      'aria-haspopup':'listbox',
      role:'combobox',
      'aria-controls':this.resource +'-subject-dropdown',
      id:this.resource+'-subject-dropdown-button',
      'data-role':'trigger',
      'aria-label': `${this.resource === 'presentlevel' ? 'Present Levels' : this.resource} - ${this.label}`
    }"
    :dom-attributes="{
      role:'listbox',
      id: this.resource + '-subject-dropdown',
      'aria-labelledby':this.resource + '-subject-dropdown-button'
    }"
  >
    <template slot="button-contents">
      {{ label }}
      <span class="caret"/>
    </template>
    <template slot="dropdown-items">
      <li
        v-for="subject in subjects"
        @click="setFilter(subject)"
        :key="subject"><a @click.prevent href="">{{ subject }}</a></li>
    </template>
  </A11yDropdown>
</template>

<script>
import A11yDropdown from '@/components/A11yDropdown'

export default {
  name: 'SubjectFilter',
  components:{A11yDropdown},
  data() {
    return {
      selectedFilter: '',
      label: 'All Subjects'
    }
  },
  props: {
    subjects: {
      type: Array,
      required: true
    },
    resource: {
      type: String,
      required: true,
      validator: function(val) {
        return ['goals', 'strategies', 'presentlevel'].indexOf(val) > -1
      }
    },
    page: {
      type: String,
      required: true,
      validator: function(val) {
        return ['favorites', 'library'].indexOf(val) > -1
      }
    }
  },
  watch: {
    selectedFilter: function() {
      this.setFilter(this.selectedFilter)
    }
  },
  methods: {
    setFilter: function(filter) {
      this.$sendEvent('Selected Favorites Subject Filter', {
        resource_type: this.resource,
        filter
      })
      this.label = filter
      this.$store.dispatch(this.page + '/setFilter', {
        type: this.resource,
        filter: filter
      })
    }
  }
}
</script>

<style scoped>
.inline-block {
  display: inline-block;
  margin-bottom: 24px;
}
</style>
